module.exports = __webpack_public_path__ + "components/flag/static/square/id-97ae43c57d4c1796ce3dbb68f1b64092.svg";